import { render, staticRenderFns } from "./MatchingLayout.vue?vue&type=template&id=64358c32"
import script from "./MatchingLayout.vue?vue&type=script&lang=js"
export * from "./MatchingLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports